export default class AbstractNotification {

  constructor(notification, sender) {
    this.room = notification.title.replace('@', '');
    this.id = notification.payload._id;
    this.rid = notification.payload.rid;
    this.sender = sender;
  }

  isAtChatStream(user) {
    return this.room === user;
  }

  accept(dispatch, history) {
    throw new Error('AbstractNotification:accept() method should be implemented');
  }

  decline(dispatch) {
    throw new Error('AbstractNotification:decline() method should be implemented');
  }

  timeOut(dispatch) {
    throw new Error('AbstractNotification:timeOut() method should be implemented');
  }

  notify(dispatch, history) {
    throw new Error('AbstractNotification:notify() method should be implemented');
  }
}
